<div class="mb-3">
  <label *ngIf="hasLabel" class="form-label" [attr.for]="label">
    {{ label | translate }}
  </label>

  <ng-select
    [formControl]="field"
    [multiple]="multiple"
    [items]="flatOptions"
    [groupBy]="isProctoringOption ? 'groupName' : ''"
    [bindLabel]="'label'"
    [bindValue]="'value'"
    [clearable]="false"
    [searchable]="true"
    [closeOnSelect]="!multiple"
    (change)="selectionChange.emit($event)"
    [attr.id]="label"
    #autoFocusInput
  >
    <ng-template ng-option-tmp let-item="item">
      {{ localizeDate ? (item.label | localizedDate) : (item.label | translate) }}
    </ng-template>

    <ng-template ng-optgroup-tmp let-item="item">
      {{ item.groupName | translate }}
    </ng-template>
  </ng-select>

  <div *ngIf="hasHint" class="form-text">{{ hint | translate }}</div>
  <div *ngIf="showError" class="form-text text-danger">{{ error | translate }}</div>
</div>
